export { default } from './PageWelcomeDynamicBG';
export * from './PageWelcomeDynamicBG';
